// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLayout_root__3wbAG","box":"AppLayout_box__2d5CW","copylight":"AppLayout_copylight__3CLnz"};